document.addEventListener('DOMContentLoaded', function() {
  const stickyButton = document.querySelector('.product-form__sticky-buy-button');
  const originalButton = document.querySelector('.product-form__btn:not(.product-form__sticky-buy-button .product-form__btn)');
  const footer = document.querySelector('footer, .footer, #shopify-section-footer');
  
  if (!stickyButton || !originalButton) return;
  
  let hasScrolledPastButton = false;
  let isFooterVisible = false;
  
  const buttonObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      // Als button uit beeld gaat EN we scrollen naar beneden
      if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
        hasScrolledPastButton = true;
      } else if (entry.isIntersecting) {
        hasScrolledPastButton = false;
      }
      updateStickyVisibility();
    });
  }, { threshold: 0 });
  
  const footerObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      isFooterVisible = entry.isIntersecting;
      updateStickyVisibility();
    });
  }, { threshold: 0, rootMargin: '0px 0px -50px 0px' });
  
  function updateStickyVisibility() {
    if (hasScrolledPastButton && !isFooterVisible) {
      stickyButton.classList.add('is-visible');
    } else {
      stickyButton.classList.remove('is-visible');
    }
  }
  
  buttonObserver.observe(originalButton);
  if (footer) footerObserver.observe(footer);
});
